var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"base"},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_x56hejikcb2w6j3xceumrac5f4/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06dcdfe0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_x56hejikcb2w6j3xceumrac5f4/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = +zMR
// module chunks = 1